import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import SidebarStudent from "./Utils/SidebarStudent";
import CreateGraduationdetails, { GraduationdetailsFormRef } from "./Resource/CreateGraduationdetails";

import "./Dashboard.css";
import "./CollegeDetails.css";
import { logout } from "../apis/backend";
import LogoutButton from "./LogoutButton";

export default function CollegeDetails() {
  const navigate = useNavigate();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState<"success" | "error">("success");

  const edu3Ref = useRef<GraduationdetailsFormRef>(null);

  const handleSave = async () => {
    try {
      setIsSaving(true);
      if (edu3Ref.current) {
        await edu3Ref.current.save();
        
        const gErrors = edu3Ref.current.getErrors();
        if (Object.keys(gErrors).length > 0) {
          setToastMessage("Please complete all required fields.");
          setToastType("error");
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
          return;
        }

        setToastMessage("College details saved successfully!");
        setToastType("success");
      }
    } catch (error) {
      console.error("Error saving details:", error);
      setToastMessage("Error saving details. Please try again.");
      setToastType("error");
    } finally {
      setIsSaving(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  return (
    <div className="dash-layout">
      {/* Sidebar */}
      <SidebarStudent
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={() => setSidebarCollapsed((p) => !p)}
      />

      {/* Main Wrapper */}
      <div
        className={`dash-wrapper ${sidebarCollapsed ? "dash-wrapper-collapsed" : ""
          }`}
      >
        {/* Header */}
        <header className="dash-header">
          <h1 className="dash-page-title">Declarations & Payment</h1>

          <div className="dash-user-profile">
            <div
              className="dash-profile-circle"
              onClick={() => setShowDropdown((p) => !p)}
            >
              <span>S</span>
            </div>

            {showDropdown && (
              <div className="dash-profile-dropdown">
                <LogoutButton />
              </div>
            )}
          </div>
        </header>

        {/* Page Content */}
        <div className="dash-content-body">
          {/* Education Details 3 Form */}
          <CreateGraduationdetails ref={edu3Ref} />

          {/* Save Button */}
          <div className="form-actions">
            <button
              className="save-btn"
              type="button"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          className="toast-container position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: 11 }}
        >
          <div
            className={`toast show align-items-center text-white bg-${toastType === "success" ? "success" : "danger"
              } border-0`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body">
                {toastMessage}
              </div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
